import { render, staticRenderFns } from "./ProductComponentLinkDialog.vue?vue&type=template&id=7e00ba4a&scoped=true&"
import script from "./ProductComponentLinkDialog.vue?vue&type=script&lang=js&"
export * from "./ProductComponentLinkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e00ba4a",
  null
  
)

export default component.exports